import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { firstValueFrom } from 'rxjs'

import { environment } from '../../../../environments/environment'
import { FlashMessageService } from '../../../abacus/services/flash-message.service'

@Component({
  selector: 'app-policy-initiative-export',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <!-- Heading -->
    <div class="is-flex flex-mobile is-justify-content-space-between is-align-items-center mb-2">
      <div class="left-part">
        <h1 class="title is-2 has-text-weight-light">
          <span class="icon is-large">
            <i class="icon icon-download is-size-2 has-text-link"></i>
          </span>
          Export AI Initiatives
        </h1>
      </div>
    </div>

    <!-- Content -->
    <div class="card p-5 mb-6 mt-4">
      <p class="mb-4">
        Download a complete export of all AI initiatives as an Excel file.
        This will generate a file containing all policy initiatives in the database,
        including all their metadata and relationships.
      </p>

      <button
        class="button is-link"
        [class.is-loading]="isExporting"
        [disabled]="isExporting"
        (click)="exportInitiatives()"
      >
        @if (!isExporting) {
          <span class="icon">
            <i class="icon icon-download"></i>
          </span>
        }
        <span>{{ isExporting ? 'Generating export...' : 'Download Excel Export' }}</span>
      </button>
    </div>
  `
})
export class PolicyInitiativeExportComponent {
  private http = inject(HttpClient)
  private flashMessageService = inject(FlashMessageService)

  isExporting = false

  async exportInitiatives(): Promise<void> {
    this.isExporting = true

    try {
      const response = await firstValueFrom(
        this.http.get<any>(`${environment.apiBaseUrl}/policy-initiatives/export`)
      )

      // Handle response - may be string (needs parsing) or already parsed object
      let data = response
      if (typeof response === 'string') {
        data = JSON.parse(response)
      }

      // Trigger download
      const downloadUrl = `${environment.storagePath}/${data.filePath}`
      window.open(downloadUrl, '_blank')

      this.flashMessageService.success('Export generated successfully!')
    } catch (error) {
      console.error('Export failed:', error)
      this.flashMessageService.error(
        'Failed to generate export. Please try again or contact support.'
      )
    } finally {
      this.isExporting = false
    }
  }
}
